import Modal from '@mui/material/Modal';
import React from 'react';

import TheInformationLogo from 'images/the-information-logo.svg';

const TIModal = (props) => {
  const {
    children,
    isOpen,
    onClose,
    parentClass,
    withLogo = false,
    disableScrollLock,
    customHeader = false,
    ...newProps
  } = props;
  return (
    <Modal open={isOpen} onClose={onClose} disableScrollLock={disableScrollLock} {...newProps}>
      <div className={`TIModal ${parentClass || ''}`}>
        <div className="modal-container">
          {!customHeader ? (
            <>
              <button className="close-button" onClick={onClose}></button>
              <div className="wrapper">
                {withLogo && (
                  <div className="logo-header">
                    <img src={TheInformationLogo} width={225} />
                  </div>
                )}
                {children}
              </div>
            </>
          ) : (
            <>{children}</>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TIModal;
